// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1braglyw._1braglyw{list-style-type:none}
._1yxxidpf._1yxxidpf{padding-left:0}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/task-decision/dist/esm/components/compiled/DecisionList.compiled.css"],"names":[],"mappings":"AAAA,qBAAqB,oBAAoB;AACzC,qBAAqB,cAAc","sourcesContent":["._1braglyw._1braglyw{list-style-type:none}\n._1yxxidpf._1yxxidpf{padding-left:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
